export default "__VITE_ASSET__BfsHRp8n__"